import $ from 'jquery'

class HelpersService {
  openTooltip (e) {
    this.closeTooltip()
    const $this = $(e)
    const message = $this.parent().find('.tooltipMessage')
    message.css('top', parseInt($this.css('top')) + $this.height() + 15)
    message.css('left', parseInt($this.css('left')) - message.width() / 2 - 6)
    message.addClass('active')
  }

  closeTooltip () {
    $('.tooltipMessage.active').removeClass('active')
  }
}

export default HelpersService



// WEBPACK FOOTER //
// ./src/app/services/common/helpers.service.js